var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"label":_vm.label,"value":_vm.input,"clearable":"","rules":_vm.rules,"suffix":_vm.suffix},on:{"input":_vm.emit}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }